import { find } from 'lodash'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import NoPermission from './NoPermission'

export default function CustomRoute({ perm, ...props }) {
  const permissions = useSelector((state) => state.account.permissions)

  const renderNoPermission = useMemo(() => {
    if (permissions && perm && !find(permissions.pages || [], { name: perm })) {
      const key = props.render ? 'render' : 'component'
      return {
        [key]: (props) => <NoPermission {...props} />
      }
    }
    return {}
  }, [perm, permissions])

  return <Route {...props} {...renderNoPermission} />
}
